import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = '';

const NewArrivals = () => {
  const navigate = useNavigate();
  const [collectionImages, setCollectionImages] = useState([]);

  useEffect(() => {
    const fetchCollectionImages = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/images`);
        if (response.ok) {
          const images = await response.json();
          // Only show 'collection' category images - NOT gallery
          const collection = images.filter(img => img.category === 'collection');
          setCollectionImages(collection.slice(0, 3));
        }
      } catch (error) {
        console.error('Error fetching collection images:', error);
      }
    };
    fetchCollectionImages();
  }, []);

  // Don't render section if no images
  if (collectionImages.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">
            Come check out our New Arrivals
          </h2>
          
          {/* Show uploaded collection images with descriptions */}
          <div className={`grid gap-8 mb-10 ${collectionImages.length === 1 ? 'grid-cols-1 max-w-2xl mx-auto' : collectionImages.length === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-3'}`}>
            {collectionImages.map((image) => (
              <div key={image.id} className="text-center">
                <div className="overflow-hidden rounded-xl shadow-lg mb-4">
                  <img 
                    src={image.url.startsWith('/api') ? `${BACKEND_URL}${image.url}` : image.url}
                    alt="New Collection"
                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                {image.alt_text && (
                  <p className="text-gray-700 text-base leading-relaxed px-2">{image.alt_text}</p>
                )}
              </div>
            ))}
          </div>
          
          <button 
            onClick={() => navigate('/contact#contact-form')}
            className="bg-red-600 text-white px-8 py-3 rounded-md hover:bg-red-700 transition-all font-medium"
          >
            Visit Us Now & Save
          </button>
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;
